var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart08-template',{attrs:{"board-ids":[242],"data-type":_vm.dataType,"field-code":"workplace-material","graph-id":62,"title":"(원료·제조물 사업장) 비상조치계획수립 현황","unit":"건"}})
}
var staticRenderFns = []

export { render, staticRenderFns }